module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/interface/header-logo-4be3baf45458ed09e18d0da0ea8b0aaf.svg";